import ProductCard from "./ProductCard"

export default function ProductGrid({
products = [],
title,
}) {
if (!products.length) {
return (
<section className="py-12">
<div className="bg-white border border-gray-100 rounded-2xl p-10 text-center">
<h2 className="text-2xl font-bold text-gray-900">
Aucun produit trouvé
</h2>

      <p className="mt-3 text-gray-600">
        Aucun produit ne correspond à votre recherche.
      </p>
    </div>
  </section>
)

}

return (
<section>

  {title && (
    <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-8">
      <div>
        <h2 className="text-2xl md:text-3xl font-bold text-gray-900">
          {title}
        </h2>

        <p className="mt-2 text-gray-600">
          {products.length} produit
          {products.length > 1 ? "s" : ""} disponible
          {products.length > 1 ? "s" : ""}
        </p>
      </div>
    </div>
  )}

  <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-6">
    {products.map((product) => (
      <ProductCard
        key={product.id}
        product={product}
      />
    ))}
  </div>

</section>

)
}